import { scaleOrdinal } from "d3-scale";
import departments from "../data/departments.json"

// const typesSet = [... new Set(departments.map(d => d['Department Type']))]
const typesSet = ['Public Safety', 'General Debt Service', 'General Government', 'Human & Cultural', 'Development & Maintenance', 'Admin'] // Intentional order
const colorScale = scaleOrdinal()
.domain(typesSet)
    .range([
      "#b33838", // "#9e2b56", //"#85144b",
      "#499342", // "#3c844e",
      "#3a2e2e", // "#c25549", // "goldenrod",
      "steelblue",
      "#FF851B ",
      "#634293", // "#001f3f",
    ]);

export default colorScale;